import { Fragment, useMemo } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import HeaderCard from "../../../Components/Common/Component/HeaderCard";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable"; 
import { createColumnHelper } from "@tanstack/react-table";
export const WithdrawalList = () => {
   const { getData } = useDataFetch();
  
    const { data, isLoading } = getData(
      ["withdrawal"],
      "/withdrawal/all",
      {
        enabled: true,
      }
    );
      
    
    
  const columnHelper = createColumnHelper();

  const columns = useMemo(() => [
    columnHelper.accessor("name", { header: "Nombre" }),
    columnHelper.accessor("email", { header: "Correo" }),
    columnHelper.accessor("state", { 
      header: "Estado",
      cell: info => {
        const state = info.getValue();
        return state? "Activo" : "Inactivo";
      }
    }),
    columnHelper.accessor("createdAt", {
      header: "Fecha",
        cell: info => {
        const rawDate = info.getValue();
        const date = new Date(rawDate);
        return date.toLocaleDateString(); 
      }
    }),
    
   /*  columnHelper.display({
      id: "acciones",
      header: "Acciones",
      cell: props => <button onClick={() => alert(props.row.original.id)}>Ver</button>
    }) */
  ], [columnHelper]);

 
  return (
    <Fragment>
      <Breadcrumbs parent="Red" title="Retiros" mainTitle="Retiros" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <HeaderCard title="Retiros registrados" />
              <CardBody>
                  <DataTable data={data?.data?.withdrawals??[]} columns={columns} progressPending={isLoading}  />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}